// Copyright © 2015-2020 TrampleZone LLC All Rights Reserved

// FaqView Module

// Show list of FAQs by section and order within section.  Data is organized
// as follows:
//
// <sectionName>: {
//     faqs: <faqsArray> {
//          importance: <importance>
//          question: <question>
//          answer: <answer>
//     }
// }

define('FaqView',['require','jquery','Faq','Utilities'],function (require) {
    'use strict';

    var // Require.js module dependencies
        $ = require('jquery'),
        Faq = require('Faq'),
        Utilities = require('Utilities'),

        // Dependent Resources
        faq = new Faq(),
        utilities = new Utilities(),

        // Instance variables
        name = 'FaqView',
        self,
        main,
        clientDiv,
        faqs = [],
        sections,
        sectionName,
        faqDivMinWidth = 320,
        faqDivMaxWidth = 600,
        headerSize = 50,
        showClass = 'show-answer',
        appName = utilities.getApplicationName() || window.appName,
        initialized = false,

        // HTML elements
        doc = window.document,
        div = doc.createElement('div'),
        faqDiv = doc.createElement('div'),
        frameDiv = doc.createElement('div'),
        titleDiv = doc.createElement('div'),
        titleSpan = doc.createElement('span'),
        buttonsDiv = doc.createElement('div'),
        sectionsDiv = doc.createElement('div'),
        footerDiv = doc.createElement('div'),
        footerSpan = doc.createElement('span'),

        // HTML elements created later
        faqsDiv,
        buttonDiv,
        buttonSpan,
        sectionDiv,
        sectionAnchor,
        sectionTitleDiv,
        sectionTitleValueDiv,
        sectionTitleValueSpan,
        sectionTitleActionDiv,
        sectionScrollTopDiv,
        sectionScrollTopSpan,
        faqQuestionDiv,
        faqQuestionSpan,
        faqAnswerDiv,
        faqAnswerP,
        faqItemDiv,
        buttonDivs;


    // Constructor
    function FaqView () {
        // Preserve instance reference and enforce singleton
        if (typeof self === 'object') { return self; } else { self = this; }

        // Get client FAQs for early display while fetching FAQs from server
        var parentApp = window.top.TRAMPLEZONE;
        if (typeof parentApp != 'undefined' && parentApp != null) {
            // Get context sensitive FAQs for embedding apps
            faqs = faqs.concat(parentApp.appFaqs || []);

            // Get base FAQs for client app
            faqs = faqs.concat(parentApp.baseFaqs ||
                               faq.getClientFaqs());

            // Get header size from app displaying FAQs
            if (typeof parentApp.appHeaderSize != 'undefined' &&
                parentApp.appHeaderSize != null) {
                headerSize = parentApp.appHeaderSize;
            }
        } else {
            // Get default client FAQs
            faqs = faqs.concat(faq.getClientFaqs());
        }


        // Public Methods

        // Update faq div bounds as window size changes
        this.updateBounds = function () {
            var width =  (clientDiv ? clientDiv.clientWidth
                                    : doc.body.clientWidth),
                height = (clientDiv ? clientDiv.clientHeight
                                    : frameDiv.clientHeight);

            // Update width
            if (width > faqDivMaxWidth) {
                width = faqDivMaxWidth;
            } else {
                if (width < faqDivMinWidth) {
                    width = faqDivMinWidth;
                }
            }
            faqDiv.style.width = width + 'px';

            // Update height
            var element = (clientDiv ? div : faqDiv);
            element.style.height = height + 'px';
        };

        // Store faqs by section and relative importance
        this.organizeFaqs = function () {
            // Initialize sections map
            sections = {};

            // Add FAQs into separate sections
            for (var i=0; i<faqs.length; i++) {
                sectionName = faqs[i].section;
                // Create section if needed
                if (typeof sections[sectionName] === 'undefined') {
                    sections[sectionName] = {};
                    sections[sectionName].faqs = [];
                }
                // Add Faq to section array, do not add if importance is 0
                if (faqs[i].importance > 0) {
                    sections[sectionName].faqs.push(faqs[i]);
                }
            }

            // Sort section FAQ arrays
            for (var section in sections) {
                utilities.sortBy(sections[section].faqs, 'importance');
            }
        };

        // Show faq answer
        this.showFaqAnswer = function (answerDiv, visible) {
            if (visible) {
                answerDiv.classList.add(showClass);
            } else {
                answerDiv.classList.remove(showClass);
            }
        };

        // Show all faqs in section
        this.showSectionAnswers = function (sectionDiv, visible) {
            // Add/Remove visible class
            if (visible) {
                sectionDiv.classList.add(showClass);
            } else {
                sectionDiv.classList.remove(showClass);
            }
            // Show/hide answers in section
            var answerPs = sectionDiv.getElementsByTagName('p');
            for (var i=0; i<answerPs.length; i++) {
                this.showFaqAnswer(answerPs[i].parentElement, visible);
            }
        };

        this.showAllAnswers = function (visible) {
            // Add/Remove visible class
            if (visible) {
                frameDiv.classList.add(showClass);
            } else {
                frameDiv.classList.remove(showClass);
            }
             // Show/Hide all answers in all sections
            var sectionDivs = sectionsDiv.children;
            for (var i=0; i<sectionDivs.length; i++) {
                this.showSectionAnswers(
                    sectionDivs[i], visible);
            }
        };

        // Display faqs in sections with hot links from the top of the view
        this.constructFaqView = function () {

            // Reset collection divs
            while (buttonsDiv.hasChildNodes()) {
                buttonsDiv.removeChild(buttonsDiv.lastChild);
            }
            while (sectionsDiv.hasChildNodes()) {
                sectionsDiv.removeChild(sectionsDiv.lastChild);
            }

            // Reset button divs array
            buttonDivs = [];

            // Convert sections map to array and put app specific first
            var sectionsArray = [],
                sectionMap;
            for (var section in sections) {
                if (section == appName) {
                    sectionMap = {};
                    sectionMap[section] = sections[section];
                    sectionsArray.push(sectionMap);
                    break;
                }
            }
            for (var section in sections) {
                if (section != appName) {
                    sectionMap = {};
                    sectionMap[section] = sections[section];
                    sectionsArray.push(sectionMap);
                }
            }

            // Iterate through sections
            var section,
                sectionName;
            for (var i=0; i<sectionsArray.length; i++) {

                // Get section name
                section = sectionsArray[i];
                sectionName = Object.keys(section)[0];

                // Create section button for anchor
                buttonSpan = doc.createElement('span');
                buttonSpan.innerHTML = sectionName;
                buttonDiv = doc.createElement('div');
                buttonDiv.appendChild(buttonSpan);
                buttonsDiv.appendChild(buttonDiv);
                buttonDivs.push(buttonDiv);

                // Section Title
                sectionTitleValueSpan = doc.createElement('span');
                sectionTitleValueSpan.innerHTML = sectionName + ' FAQs';
                sectionTitleValueDiv = doc.createElement('div');
                sectionTitleValueDiv.appendChild(sectionTitleValueSpan);
                sectionScrollTopSpan = doc.createElement('span');
                sectionScrollTopSpan.innerHTML = '^';
                sectionScrollTopDiv = doc.createElement('div');
                sectionScrollTopDiv.appendChild(sectionScrollTopSpan);
                sectionTitleActionDiv = doc.createElement('div');
                sectionTitleActionDiv.appendChild(sectionScrollTopDiv);
                sectionTitleDiv = doc.createElement('div');
                sectionTitleDiv.appendChild(sectionTitleValueDiv);
                sectionTitleDiv.appendChild(sectionTitleActionDiv);

                // Add expand/collapse for all answers in section
                utilities.addEventListeners(sectionTitleDiv,
                                            function (sectionTitleDiv) {
                    var sectionDiv = sectionTitleDiv.parentElement;
                    this.showSectionAnswers(
                        sectionDiv, !sectionDiv.classList.contains(showClass));
                }.bind(this, sectionTitleDiv));

                // Section Faqs
                faqsDiv = doc.createElement('div');
                var sectionFaqs = section[sectionName].faqs;
                for (var j=0; j<sectionFaqs.length; j++) {
                    // Container
                    faqItemDiv = doc.createElement('div');
                    // Question
                    faqQuestionSpan = doc.createElement('span');
                    faqQuestionSpan.innerHTML = sectionFaqs[j].question;
                    faqQuestionDiv = doc.createElement('div');
                    faqQuestionDiv.appendChild(faqQuestionSpan);
                    // Answer
                    faqAnswerP = doc.createElement('p');
                    faqAnswerP.innerHTML = sectionFaqs[j].answer;
                    faqAnswerDiv = doc.createElement('div');
                    faqAnswerDiv.appendChild(faqAnswerP);
                    // Assemble
                    faqItemDiv.appendChild(faqQuestionDiv);
                    faqItemDiv.appendChild(faqAnswerDiv);
                    faqsDiv.appendChild(faqItemDiv);
                    // Add expand/collapse listener
                    utilities.addEventListeners(faqQuestionDiv,
                                                function (faqAnswerDiv) {
                        this.showFaqAnswer(faqAnswerDiv,
                            !faqAnswerDiv.classList.contains(showClass));
                    }.bind(this, faqAnswerDiv));
                }

                // Add faqs to section div
                sectionDiv = doc.createElement('div');
                sectionDiv.appendChild(sectionTitleDiv);
                sectionDiv.appendChild(faqsDiv);

                // Add section to collection
                sectionsDiv.appendChild(sectionDiv);

                // Add smooth scrolling to top
                utilities.addEventListeners(sectionScrollTopDiv, function (event) {
                    event.stopPropagation();
                    var save = div.style.overflowY; // Android workaround
                    div.style.overflowY = 'hidden'; // Android workaround
                    $(div).animate({scrollTop: 0}, 'slow');
                    div.style.overflowY = save;     // Android workaround
                });

                // Add smooth scrolling to sections
                utilities.addEventListeners(buttonDiv, function (sectionDiv) {
                    var top = sectionDiv.getBoundingClientRect().top -
                         headerSize - 10;
                    var save = div.style.overflowY; // Android workaround
                    div.style.overflowY = 'hidden'; // Android workaround
                    $(div).animate({scrollTop: top}, 'slow');
                    div.style.overflowY = save;     // Android workaround
                }.bind(this, sectionDiv));

            }
        };

        // Scale button text to fit
        this.scaleButtonText = function () {
            for (var i=0; i<buttonDivs.length; i++) {
                var container = buttonDivs[i],
                    text = container.children[0].innerHTML,
                    defaultFontSize = container.children[0].style.fontSize;
                utilities.setFontSizeToFit(buttonDivs[i], text, defaultFontSize);
            }
        };

        // Update the footer with the count of FAQS
        this.updateFooterCount = function () {
            footerSpan.innerHTML = faqs.length + ' Frequently Asked Questions';
        };
    }


    // Public Prototype Methods

    // Initialization
    FaqView.prototype.initialize = function (newMain) {
        // Save references to Main and clientDiv
        if (newMain) {
            main = newMain;
            clientDiv = main.getClientDiv();
            headerSize = main.getLogoDivHeight();
        }

        // Title
        titleSpan.innerHTML = 'Frequently Asked Questions';
        titleDiv.appendChild(titleSpan);
        // Add expand/collapse for all answers in all sections
        utilities.addEventListeners(titleDiv, function () {
            this.showAllAnswers(!frameDiv.classList.contains(showClass));
        }.bind(this));

        // Store faqs in sections, sorted by importance
        this.organizeFaqs();

        // Display FAQs in sections with anchors from top
        this.constructFaqView();

        // Update footer count
        this.updateFooterCount();

        // Assemble elements
        frameDiv.appendChild(titleDiv);
        frameDiv.appendChild(buttonsDiv);
        frameDiv.appendChild(sectionsDiv);
        footerDiv.appendChild(footerSpan);
        faqDiv.appendChild(frameDiv);
        faqDiv.appendChild(footerDiv);
        div.appendChild(faqDiv);

        // Add top level id
        div.setAttribute('id', 'faq-div');

        // Scale font until the section name fits on the buttons
        setTimeout(this.scaleButtonText, 1000);

        // Retrieve Server FAQs (fetched from the server in the background)
        faq.getServerFaqs(function (response) {
            if (response && (response.status == 'PASS' || response.status == '0')) {
                if (response.faqs && response.faqs.length > 0) {
                    // Add new faqs from the server to the list
                    var index;
                    for (var i=0; i<response.faqs.length; i++) {
                        if (response.faqs[i]) {
                            // Does the question already exist in the Client list?
                            index = -1;
                            for (var j=0; j<faqs.length; j++) {
                                if (response.faqs[i].question === faqs[j].question) {
                                    index = j;
                                    break;
                                }
                            }
                            // Replace if it exists in Client, otherwise add
                            if (index >= 0) {
                                faqs[j] = response.faqs[i];
                            } else {
                                faqs.push(response.faqs[i]);
                            }
                        }
                    }
                    // Rebuild with expanded set of FAQs
                    this.organizeFaqs();
                    this.constructFaqView();
                    this.updateFooterCount(faqs.length);
                }
            }
        }.bind(this));

        initialized = true;
    };

    // Get the initialization status
    FaqView.prototype.isInitialized = function () {
        return initialized;
    };

    // Refresh bounds before displaying
    FaqView.prototype.updateView = function () {
        this.updateBounds();
    };

    // Reset
    FaqView.prototype.reset = function () {
        // Nothing for now
    };

    // Back button actions
    FaqView.prototype.handleBack = function () {
        // Return to main, hiding any ads if present
        if (main) {
            // Mobile
            main.showAd(false, function () {
                main.showView(main.getCurrentView());
                main.closeView(this);
                setTimeout(function () {
                    this.showAllAnswers(false);
                }.bind(this), 1000);
            }.bind(this));
        } else {
            // Web
            $('#faq-parent-div').fadeOut(400, function () {
                $('#sizzle-div').fadeIn(400);
            });
        }
    };

    // Get name of class
    FaqView.prototype.getName = function () {
        return name;
    };

    // Get the content div
    FaqView.prototype.getContentDiv = function () {
        return frameDiv;
    }

    // Get the main div container for this view
    FaqView.prototype.getDiv = function () {
        return div;
    };

    // Return Constructor
    return FaqView.prototype.constructor;
});

